import { notification } from "antd";
import { publicAPI } from "../../Config/Constant";
import store from "../store";


export const getDomain = async (payload) => {
  try {
    const res = await publicAPI.get(
      `/campaignDomain/get/${payload.organizationid}?page=payload.page`

    );

    if (res) {
      // console.log('res',res);

      if (res) {
        store.dispatch({
          type: "SET_ALL_DOMAIN",
          payload: res.data.data,
        });

        return res;
        // }
      }
    }
  } catch (err) {
    //    console.error('Error during login:', err);
    notification.error({
      message: err?.response?.data?.message || "Server Error",
      duration: 3,
    });
  }
};
